import _ from "lodash";


class Address {
  constructor(data) {
    _.merge(this, data);

    this.streetName = data.streetName || null;
    this.streetNumber = data.streetNumber || null;
    this.city = data.city || null;
    this.zipCode = data.zipCode || null;
  }

  format() {
    return this.streetName + ' ' + this.streetNumber + ', ' + this.zipCode + ' ' + this.city;
  }
}

export default Address;



// WEBPACK FOOTER //
// ./client/domain/address.js